import { gql, useQuery } from '@apollo/client';
// import { useContentfulLiveUpdates } from "@contentful/live-preview/react";
import * as BookingAlertCM from '../contentModels/BookingAlertCM';


interface BookingAlertData {
    bookingAlertCollection: { items: BookingAlertCM.BookingAlert[] }
}

const useGlobalBookingAlert = (language: string = "en", venueCode: string) => {

    //Fetch the global booking alerts that are either
    // unfiltered (filterMode = none) 
    // OR opt-in AND have the venue listed
    // OR opt-out and don't have the venue listed

    const query = gql`
        query GetBookingAlerts {
            bookingAlertCollection(
                locale: "${language}",
                where: {
                    OR: [
                        { filterMode: "None" },
                        {
                            AND: [
                                { filterMode: "Opt-in" },
                                { venueCodes_contains_some: ["${venueCode}"] }
                            ]
                        },
                        {
                            AND: [
                                { filterMode: "Opt-out" },
                                { venueCodes_contains_none: ["${venueCode}"] }
                            ]
                        }
                    ]
                },
                limit: 5
            ) {
                items {
                    ${BookingAlertCM.query}
                }
            }
        }
    `;


    const { loading, error, data } = useQuery<BookingAlertData>(query);

    // const liveData = useContentfulLiveUpdates(data);
    const liveData = data;
    return { loading, error, liveData };
};

export default useGlobalBookingAlert;
